export const publisherRoutes = {
  dashboard: '/publisher/dashboard',
  ads: '/publisher/ads',
  sites: '/publisher/sites',
  'site-adunits': '/publisher/sites/:siteId/ad-units',
  statistics: '/publisher/statistics',
  content: '/publisher/content',
  newSliderContent: '/publisher/content/slider/new',
  sliderContent: '/publisher/content/slider/:id',
  newVideoContent: '/publisher/content/video/new',
  videoContent: '/publisher/content/video/:id',
  flow: '/publisher/flow',
  payments: '/publisher/payments',
  referrals: '/publisher/referrals',
  profile: '/publisher/profile',
  index: '/publisher',
} as const;

export const commons = {
  signin: '/signin',
  signup: '/signup',
  'login-as-user': '/login-as-user',
  'password-recovery': '/password-recovery',
  confirmation: '/confirmation',
  'not-verified': '/not-verified',
  'resend-email': '/resend-email',
  index: '/',
} as const;
